import { render, staticRenderFns } from "./PortfolioGridCaption.vue?vue&type=template&id=47f2603b&"
import script from "./PortfolioGridCaption.vue?vue&type=script&lang=js&"
export * from "./PortfolioGridCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports